import { RequestGatewayPlugin } from "../../../type";
import Cookies from "js-cookie";

const getSavedFingerprintID = () => {
  try {
    let requestId: string | undefined | null = Cookies.get("requestId");

    // 服务端渲染时，window对象是不存在的，所以需要判断是否存在window对象
    // 不能直接用 window != null, 因为 window 是不存在的，仍然会报错 ReferenceError: window is not defined
    // https://stackoverflow.com/questions/55151041/window-is-not-defined-in-next-js-react-app
    if (!requestId && typeof window !== "undefined" && window.localStorage) {
      requestId = window.localStorage.getItem("requestId");
    }
    return requestId;
  } catch (error) {
    log("getSavedFingerprintID error: ", error);
  }
  return null;
};

const TAG = "[FP]";

const log = (message?: any, ...optionalParams: any[]) => {
  if (optionalParams.length == 0) {
    console.log(`${new Date().getTime()} ${TAG} ${!!message ? message : ""}`);
    return;
  }
  console.log(
    `${new Date().getTime()} ${TAG} ${!!message ? message : ""}`,
    optionalParams,
  );
};

const fingerprintPlugin: RequestGatewayPlugin = {
  name: "fingerprintPlugin",
  type: "request",
  apply(config, options) {
    const requestId = getSavedFingerprintID();
    if (requestId) {
      config.headers.set("fp-request-id", requestId);
    }

    return config;
  },
};

export default fingerprintPlugin;
